import React, { useRef, useEffect, useMemo } from "react";
import PlayerMoveable from "./PlayerMoveable";
import PlayerControl from "./PlayerControl";
import store from "@/stores/clipEditor/player";
import trackStore from "@/stores/clipEditor/trackState";
import { CanvasPlayer } from "./canvasDraw";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { videoDecoder } from "@/utils/webcodecs";
import { VideoTrack } from "@/stores/clipEditor/class/VideoTrack";
import { baseFps } from "@/stores/clipEditor/data/trackConfig";

interface PlayerContainerProps {
  containerSize: {
    width: number;
    height: number;
  };
}

const PlayerContainer: React.FC<PlayerContainerProps> = ({ containerSize }) => {
  const playerCanvas = useRef<HTMLCanvasElement>(null);
  const playerIns = useRef(null);
  const [ctx, setCtx] = React.useState<CanvasRenderingContext2D | null>(null);

  const { playerWidth, playerHeight } = store.playerConfig;
  const stop = () => {
    //
  };

  // 计算缩放比例
  const scale = useMemo(() => {
    let { width, height } = containerSize;
    height -= 96; // 上下功能栏
    width -= 16; // 左右功能栏
    return Math.min(width / playerWidth, height / playerHeight);
  }, [containerSize, playerWidth, playerHeight]);

  const getFrameByIndex = async (frameIndex) => {
    try {
      const clip = videoDecoder.getClip();
      if (!clip) {
        return;
      }
      await clip.ready;
      const trackItem = trackStore.trackList[0]?.list.find(
        (item: Record<string, any>) => {
          if (
            store.playStartFrame >= item.start &&
            store.playStartFrame <= item.end &&
            !["audio"].includes(item.type)
          ) {
            return true;
          }
          return false;
        }
      ) as VideoTrack;
      if (!trackItem) {
        ctx?.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        return;
      }

      const time = Math.max(
        ((frameIndex + trackItem.offsetL - trackItem.start - 1) / baseFps) *
          1e6,
        (1 / 30) * 1e6
      );
      const { state, video } = await clip.tick(time);

      if (video != null && state === "success") {
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

        // console.log("clip", clip, "trackItem", trackItem);

        ctx.drawImage(
          video,
          0,
          0,
          clip.meta.width,
          clip.meta.height,
          trackItem.getDrawX(store.playerConfig.playerWidth),
          trackItem.getDrawY(store.playerConfig.playerHeight),
          trackItem.drawWidth,
          trackItem.drawHeight
        );
        video.close();
      }
    } catch (error) {
      console.log(error);
    }
  };

  // 初始化 CanvasPlayer
  // useEffect(() => {
  //   if (playerCanvas.current) {
  //     const player = new CanvasPlayer({
  //       player: playerCanvas.current,
  //       containerSize,
  //     });
  //     playerIns.current = player;
  //   }
  // }, [containerSize]);

  useEffect(() => {
    // playerIns.current.drawCanvas();
    // play();
    // console.log("playStartFrame", store.playStartFrame);

    getFrameByIndex(store.playStartFrame);

    // console.log("change", store.playStartFrame);
  }, [toJS(trackStore.trackList), store.playStartFrame]);

  return (
    <div
      className="p-2 absolute top-12 bottom-10 left-2 right-2 overflow-hidden"
      style={{
        padding: "4px",
        position: "absolute",
        top: "20px",
        bottom: "14px",
        left: "4px",
        right: "4px",
        overflow: "hidden",
        inset: 0,
      }}
    >
      <canvas
        ref={(c) => {
          setCtx(c?.getContext("2d"));
        }}
        className="absolute left-0 right-0 top-0 bottom-0 m-auto bg-gray-900"
        id="player"
        width={playerWidth}
        height={playerHeight}
        style={{
          zoom: scale,
          position: "absolute",
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          margin: "auto",
          width: `${playerWidth}px`,
          height: `${playerHeight}px`,
          background: "rgb(17 24 39)",
        }}
      />
      {/* 
      {store.frameCount === 0 || !store.existVideo ? (
        <div className="absolute left-0 right-0 top-0 bottom-0 z-20 flex justify-center items-center">
          <ElIcon size={144} className="box-content opacity-50" style={{ color: '#FDE68A' }}>
            <VideoCameraFilled />
          </ElIcon>
        </div>
      ) : null}
      */}
      {/* <Loading className="justify-center pl-0 bg-opacity-0" /> */}
      <PlayerMoveable
        style={{
          zoom: scale,
          width: `${playerWidth}px`,
          height: `${playerHeight}px`,
        }}
      />
      <PlayerControl />
    </div>
  );
};

export default observer(PlayerContainer);
